import { twMerge } from "tailwind-merge";
import { InputProps } from "./type.ts";

const TextInput = ({ className = "", error = false, ...props }: InputProps) => {
  return (
    <input
      type={props?.type || "text"}
      style={{ WebkitBoxShadow: "0 0 0px 1000px #0000 inset !important" }}
      className={twMerge(
        "relative flex w-full appearance-none focus:outline-none focus-visible:outline-none items-center justify-between gap-3 rounded-lg border border-gray-650 bg-gray-800 px-2.5 py-2 text-sm text-gray-200 placeholder:text-gray-500 focus:border-app-500 focus-visible:border-app-500",
        error ? "border-red-600 bg-red-800/10" : "",
        className
      )}
      {...props}
    />
  );
};
export default TextInput;
